module.exports = __webpack_public_path__ + "static/gate6-72378862517915011ff052fa819e8fa2.jpg";